import PropReferenceLabel from "../../../components/PropReferenceLabel";
import { Prop } from "../../../models/Prop";
import { PiInteractionDropdown } from "../../../components/PiInteractionDropdown";
import useAttachmentHelper from "../../../hooks/AttachmentHelper.hook";

export default function AttachPropDropdown(props: {
  onChange: (prop: Prop) => void;
  selectedPropId: string;
}) {
  const { onChange, selectedPropId } = { ...props };

  const { getAllAttachableProps } = useAttachmentHelper();

  const dropdownItems = getAllAttachableProps().map((prop) => {
    return (
      <PiInteractionDropdown.Item key={prop.id} onClick={() => onChange(prop)}>
        <div className={"flex justify-center gap-4 w-full"}>
          <div className={"my-auto truncate"}>{prop.name}</div>
        </div>
      </PiInteractionDropdown.Item>
    );
  });

  const dropdown = (
    <PiInteractionDropdown label={"Prop"}>
      <PiInteractionDropdown.Trigger>
        <div className={"flex gap-x-4 w-full"}>
          <div className={"my-auto truncate"}>
            <PropReferenceLabel instanceId={selectedPropId} />
          </div>
        </div>
      </PiInteractionDropdown.Trigger>
      {dropdownItems}
    </PiInteractionDropdown>
  );

  return <>{dropdown}</>;
}
